import { useZustand } from "../zustand/store";
import { useNavigate, useParams } from "react-router-dom";
import { retrieveAllArt } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, deleteArt } from "../firebase";
import { ownerData } from "../data/main.data";
import PageNotFound from "./PageNotFound";
import Button from "../components/general/Button";
import shareArt from "../functions/shareArt";
import MadeByOlaBanner from "../components/BottomBanner/MadeByOlaBanner";
import ScrollToTop from "../components/general/ScrollToTop";
import Navigation from "../components/Head/subComponents/Navigation";

let currentArtDisplay: any = "";

function Art() {
  let { slug } = useParams();

  const { artProjects, setArtProjects } = useZustand();

  const navigate = useNavigate();

  const [user] = useAuthState(auth);

  //IMPORTANT
  currentArtDisplay = "";

  if (artProjects.length === 0) {
    console.log("trying to retrieve");
    retrieveAllArt((val: any) => setArtProjects(val));
  }

  if (artProjects.length !== 0) {
    let data;
    console.log("hmm");
    data = artProjects.filter((i: any) => {
      return i.data.id === slug;
    });

    if (data.length === 0) {
      //incase of wrong art id
      currentArtDisplay = null;
    } else {
      console.log(data);
      currentArtDisplay = data[0];
    }
  }

  return (
    <div>
      <ScrollToTop />
      <div className="sticky top-0 w-full bg-white/60 backdrop-blur-sm">
        <Navigation />
      </div>
      <div className="py-2 px-3 md:px-10 w-full min-h-screen flex flex-col justify-start items-center text-black font-boska text-center">
        {currentArtDisplay === null ? (
          <PageNotFound />
        ) : currentArtDisplay === "" ? (
          <h1 className="text-3xl md:text-5xl font-black text-black font-boska">
            Loading Art!
          </h1>
        ) : (
          <div className="flex flex-col justify-start items-center gap-10">
            <div className="flex justify-center items-center gap-5">
              <Button text="Back" onClick={() => navigate(-1)} />
              <Button
                text="Share Art"
                onClick={() =>
                  shareArt(
                    currentArtDisplay.data.name,
                    currentArtDisplay.data.description
                  )
                }
              />

              {((user && user?.email === "olaoluwaadeyemo7@gmail.com") ||
                user?.email === ownerData.signInEmail) && (
                <Button
                  text="Delete Art"
                  onClick={() => deleteArt(currentArtDisplay.mainId)}
                />
              )}
            </div>

            <h1 className="text-3xl md:text-5xl font-black">
              {currentArtDisplay.data.name}
            </h1>

            <p className="text-lg md:text-xl font-light whitespace-pre-line">
              {currentArtDisplay.data.description
                .split("\n")
                .map((i: any, key: any) => {
                  return (
                    <span key={key}>
                      {i}
                      <br />
                    </span>
                  );
                })}
            </p>

            <img
              src={currentArtDisplay.data.imageUrl}
              alt={currentArtDisplay.data.name}
              className="w-full rounded-md shadow-xl transition-transform duration-1000 ease-in-out hover:cursor-pointer md:hover:scale-105"
            />

            <div className="flex justify-center pt-2">
              <MadeByOlaBanner />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Art;
